
























import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class WongBakerFacesInput extends Vue {
  @Prop({ default: 0 }) value!: number;
  @Prop({ default: 48 }) patientAgeMonths!: number;

  localVal: number = this.value || 0;

  faces = [
    { value: 0, emoji: '😊', label: 'Tidak nyeri' },
    { value: 2, emoji: '🙂', label: 'Sedikit' },
    { value: 4, emoji: '😐', label: 'Agak nyeri' },
    { value: 6, emoji: '🙁', label: 'Lebih nyeri' },
    { value: 8, emoji: '😢', label: 'Sangat nyeri' },
    { value: 10, emoji: '😭', label: 'Nyeri hebat' },
  ];

  @Watch('value')
  onValueChange(v: number) { this.localVal = v; }

  get instrumentLabel(): string {
    if (this.patientAgeMonths < 2) return 'NIPS (Neonatus)';
    if (this.patientAgeMonths <= 84) return 'FLACC Scale';
    return 'Wong-Baker Faces';
  }

  get kategoriLabel(): string {
    if (this.localVal === 0) return 'Tidak Nyeri';
    if (this.localVal <= 3) return 'Ringan';
    if (this.localVal <= 6) return 'Sedang';
    return 'Berat';
  }

  get kategoriColor(): string {
    if (this.localVal === 0) return 'green';
    if (this.localVal <= 3) return 'blue';
    if (this.localVal <= 6) return 'orange';
    return 'red';
  }

  select(val: number) {
    this.localVal = val;
    this.$emit('input', val);
  }
}
